module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_03-06b31e054a8a9ed51ec1873458123edf.png";